import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'

//components
import StyledPageContainer from '../../components/StyledPageContainer/StyledPageContainer'
import PartWise from './PartWise'
import MachineWise from './MachineWise'
import ProductionRecord from './ProductionRecord'
import DateSelectorContext from '../../context/DateSelectorContext'
import QualityRecord from './QualityRecord'
import ProductionLossIdleTime from './ProductionLossIdleTime'
import RejectionLossDailyWise from './RejectionLossDailyWise'

import * as DATE_UTILS from '../../utils/date.utils'
import DateSelector from '../../components/DateSelector'
import SpillOver from './SpillOver'

const pageTabs = {
  PART_WISE: { name: 'Part wise', value: 'part-wise' },
  MACHINE_WISE: { name: 'Machine wise', value: 'machine-wise' },
  PRODUCTION_RECORD: { name: 'Production record', value: 'production-record' },
  QUALITY_RECORD: { name: 'Quality record', value: 'quality-record' },
  PRODUCTION_LOSS: {
    name: 'Daily production loss',
    value: 'production-loss-idletime'
  },
  REJECTION_LOSS: {
    name: 'Daily rejection monitoring',
    value: 'rejection-loss'
  },
  SPILL_OVER: { name: 'Spill over', value: 'spill-over' }
}

const TabsContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignSelf: 'flex-end'
}))

const Tab = styled('div')(({ theme, isActive }) => ({
  minWidth: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '8px',
  color: isActive ? theme.palette.primary.main : '#ccccd7',
  cursor: 'pointer',
  borderBottom: isActive
    ? `1px solid ${theme.palette.primary.main}`
    : '1px solid transparent',
  '&:hover': {
    color: `${theme.palette.primary.main}`
  }
}))

const DashboardOutlet = () => {
  //default values
  let defaultTab = pageTabs.PART_WISE.value

  //hooks
  const navigate = useNavigate()
  let [searchParams] = useSearchParams()

  //extract category from URL
  const tab = searchParams.get('tab')

  if (tab) {
    defaultTab = tab
  }

  //component state
  const [activeSubTab, setActiveSubTab] = useState(defaultTab)
  const [workingDate, setWorkingDate] = useState(DATE_UTILS.workingDate())
  const [calenderDate, setCalenderDate] = useState(DATE_UTILS.workingDate())

  const dateChangeHandler = (e) => {
    setCalenderDate(e.target.value)
  }

  const submitHandler = (e) => {
    e.preventDefault()
    setWorkingDate(calenderDate)
  }

  const prevNextHandler = (actionType) => {
    setCalenderDate((prevDate) => DATE_UTILS.updateDate(actionType, prevDate))
    setWorkingDate((prevDate) => DATE_UTILS.updateDate(actionType, prevDate))
  }

  useEffect(() => {
    navigate(`?tab=${activeSubTab}`)
  }, [activeSubTab])

  const handleSubTabChange = (tab) => {
    setActiveSubTab(tab)
  }

  return (
    <StyledPageContainer>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `1px solid #eeeeee`
        }}
      >
        <TabsContainer>
          {React.Children.toArray(
            Object.values(pageTabs).map((tab, i) => (
              <Tab
                isActive={activeSubTab === tab.value}
                onClick={() => handleSubTabChange(tab.value)}
              >
                {tab.name}
              </Tab>
            ))
          )}
        </TabsContainer>
        <Box sx={{ padding: '12px 24px' }}>
          <DateSelector
            date={calenderDate}
            dateChangeHandler={dateChangeHandler}
            submitHandler={submitHandler}
            prevNextHandler={prevNextHandler}
          />
        </Box>
      </Box>
      <DateSelectorContext.Provider
        value={{
          selectedDate: workingDate
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 64.8px)',
            overflowY: 'auto'
          }}
        >
          {activeSubTab === pageTabs.PART_WISE.value && <PartWise />}
          {activeSubTab === pageTabs.MACHINE_WISE.value && <MachineWise />}
          {activeSubTab === pageTabs.PRODUCTION_RECORD.value && (
            <ProductionRecord />
          )}
          {activeSubTab === pageTabs.QUALITY_RECORD.value && <QualityRecord />}
          {activeSubTab === pageTabs.PRODUCTION_LOSS.value && (
            <ProductionLossIdleTime />
          )}
          {activeSubTab === pageTabs.REJECTION_LOSS.value && (
            <RejectionLossDailyWise />
          )}
          {activeSubTab === pageTabs.SPILL_OVER.value && (
            <SpillOver />
          )}
        </Box>
      </DateSelectorContext.Provider>
    </StyledPageContainer>
  )
}

export default DashboardOutlet
